import Button from "./Button";
import Group from "./Group";

const Radio = {
  Button,
  Group,
};

export default Radio;
